import { EnumValues, OrderByDirection } from "@hex/common";

import { MonacoEditorOptions } from "../../cell/monaco/options";

export namespace WorkbenchHistory {
  export const TimelineSortDirection = {
    ASC: "ASC",
    DESC: "DESC",
  } as const;
  export type TimelineSortDirection = OrderByDirection;

  export const VersionPanelTabId = {
    CHANGES: "changes",
    FILES: "files",
  } as const;
  export type VersionPanelTabId = EnumValues<typeof VersionPanelTabId>;

  export const VersionPanelChangesFilter = {
    ALL: "all",
    CHANGED: "changed",
  } as const;
  export type VersionPanelChangesFilter = EnumValues<
    typeof VersionPanelChangesFilter
  >;

  export type ExpandedState<
    TFileGroupId extends string,
    TFilePath extends string,
  > = Record<TFileGroupId, Record<TFilePath, boolean>>;

  export type State<
    TTimelineNodeId extends string,
    TFileGroupId extends string,
    TFilePath extends string,
  > = {
    dialog: {
      isOpen: boolean;
    };
    timeline: {
      selectedNodeId: TTimelineNodeId | null;
      sortDirection: TimelineSortDirection;
    };
    versionPanel: {
      tabId: VersionPanelTabId;
      changesFilter: VersionPanelChangesFilter;
      fileExpanded: ExpandedState<TFileGroupId, TFilePath>;
    };
    editor: {
      options: MonacoEditorOptions;
    };
  };
}
